// src/api/users.js
import { authFetch } from './interceptors';

export const usersService = {
  // ✅ CORREGIDO: authFetch ya retorna los datos parseados
  getUsers: async () => {
    try {
      //console.log('👥 Obteniendo lista de usuarios...');
      
      // authFetch ya retorna el JSON parseado, no necesitas response.json()
      const users = await authFetch('/api/user/v1/users/', {
        method: 'GET',
      });
      
      //console.log('✅ Usuarios obtenidos:', users);
      return users;
    } catch (error) {
      //console.error('❌ Error obteniendo usuarios:', error);
      throw error;
    }
  },

  // Crear un nuevo usuario
  createUser: async (userData) => {
    try {
      //console.log('📝 Creando nuevo usuario...', userData);
      
      const newUser = await authFetch('/api/user/v1/users/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });
      
      //console.log('✅ Usuario creado:', newUser);
      return newUser;
    } catch (error) {
      //console.error('❌ Error creando usuario:', error);
      throw error;
    }
  },

  // Actualizar un usuario
  updateUser: async (userId, userData) => {
    try {
      //console.log('📝 Actualizando usuario...', userId, userData);
      
      const updatedUser = await authFetch(`/api/user/v1/users/${userId}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });
      
      //console.log('✅ Usuario actualizado:', updatedUser);
      return updatedUser;
    } catch (error) {
      //console.error('❌ Error actualizando usuario:', error);
      throw error;
    }
  },

  // Eliminar un usuario
  deleteUser: async (userId) => {
    try {
      //console.log('🗑️ Eliminando usuario...', userId);
      
      const response = await authFetch(`/api/user/v1/users/${userId}/`, {
        method: 'DELETE',
      });
      
      //console.log('✅ Usuario eliminado');
      return response; // Puede ser null o un mensaje de éxito
    } catch (error) {
      //console.error('❌ Error eliminando usuario:', error);
      throw error;
    }
  },

  // Obtener un usuario específico
  getUserById: async (userId) => {
    try {
      //console.log('👤 Obteniendo usuario por ID...', userId);
      
      const user = await authFetch(`/api/user/v1/users/${userId}/`, {
        method: 'GET',
      });
      
      //console.log('✅ Usuario obtenido:', user);
      return user;
    } catch (error) {
      //console.error('❌ Error obteniendo usuario:', error);
      throw error;
    }
  }
};
